/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSearchAdminResponse } from '../models/GetSearchAdminResponse';
import type { GetSearchesByOrderIdAdminResponse } from '../models/GetSearchesByOrderIdAdminResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SearchesService {
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetSearchesByOrderIdAdminResponse OK
     * @throws ApiError
     */
    public static getSearchByOrderAdmin({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetSearchesByOrderIdAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/searches/orders/{orderId}',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetSearchAdminResponse OK
     * @throws ApiError
     */
    public static getSearchAdmin({
        searchId,
    }: {
        searchId: string,
    }): CancelablePromise<GetSearchAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/searches/{searchId}',
            path: {
                'searchId': searchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `FinishOrderSearch`
     * @returns any OK
     * @throws ApiError
     */
    public static postSearchFinishAdmin({
        searchId,
    }: {
        searchId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/searches/{searchId}/finish',
            path: {
                'searchId': searchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `FinishOrderSearch`
     * @returns any OK
     * @throws ApiError
     */
    public static postSearchFinishByOrderAdmin({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/searches/orders/{orderId}/finish',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `FinishOrderSearch`
     * @returns any OK
     * @throws ApiError
     */
    public static postSearchFinishByMealAdmin({
        mealId,
    }: {
        mealId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/searches/meals/{mealId}/finish',
            path: {
                'mealId': mealId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetSearchAdminResponse OK
     * @throws ApiError
     */
    public static getLastSearchAdmin({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetSearchAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/searches/orders/{orderId}/last',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetSearchAdminResponse OK
     * @throws ApiError
     */
    public static getLastSearchAdmin1({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetSearchAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/searches/orders/{orderId}/active',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
